import UserContext from "Context/UserProvider";
import { useContext, useEffect, useState } from "react";
import ChargingPartnerRateCardTable from "../../components/charging/ChargingPartnerRateCardComponent/ChargingPartnerRateCardTable";
import { Box, CircularProgress } from '@mui/material';
import { useApiService } from "../../services/ApiService/ApiService";

function ChargingPartnerRateCardListPage(props: any) {
    const { userInfo } = useContext(UserContext);
    const { fetchWithAuth } = useApiService();
    const [chargingPartnerRateCards, setChargingPartnerRateCards] = useState() as any;
    const [loading, setLoading] = useState(true);

    const fetchChargingPartnerRateCards = async () => {
        let bodyData: { [name: string]: string } = {};
        bodyData["uuid"] = userInfo.uuid;
        bodyData["businessUuid"] = userInfo.businessUuid;

        try {
            const response = await fetchWithAuth('/charging-partner/rate-card/list', {
                method: 'POST',
                body: JSON.stringify(bodyData),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch rate cards');
            }

            const res_json = await response.json();
            console.log(res_json.chargingPartnerRateCards);
            setChargingPartnerRateCards(res_json.chargingPartnerRateCards.map((e: any) => ({ ...e, id: e.uuid, name: e.name })));
        } catch (error) {
            console.error('Error fetching rate cards:', error);
        } finally {
            setLoading(false);
        }
    };

    const submitChargingPartnerRateCard = async (uuid: any, siteAccessChargingPartnerRateCardUuid: any, rowId: any) => {
        try {
            let bodyData: { [name: string]: string } = {};
            bodyData["uuid"] = userInfo.uuid;
            bodyData["businessUuid"] = userInfo.businessUuid;
            bodyData["chargingPartnerRateCardUuid"] = uuid;

            console.log(bodyData);

            const response = await fetchWithAuth('/charging-partner/rate-card/submit', {
                method: 'POST',
                body: JSON.stringify(bodyData),
            });

            if (!response.ok) {
                throw new Error('Failed to submit rate card');
            }

            const res_json = await response.json();

            // If the API call is successful, update the status of the corresponding row.
            const updatedData = chargingPartnerRateCards.map((row: { id: any; }) =>
                row.id === rowId ? { ...row, workflowState: res_json.workflowState } : row
            );
            setChargingPartnerRateCards(updatedData);
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };

    useEffect(() => {
        fetchChargingPartnerRateCards();
    }, []);
    return (
        <>
            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <CircularProgress />
                </Box>
            ) : (
                <ChargingPartnerRateCardTable businessChargingCategory={userInfo.businessCategory} chargingPartnerRateCards={chargingPartnerRateCards} onButtonClick={submitChargingPartnerRateCard} />
            )}
        </>
    );
}

export default ChargingPartnerRateCardListPage;
